var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mine-coupon"},[(_vm.couponList.length)?_c('div',_vm._l((_vm.couponList),function(item){return _c('div',{key:item.id,staticClass:"mine-itemWrapper"},[_c('coupon',{attrs:{"coupon":item,"isVipUser":_vm.isVipUser}})],1)}),0):_c('div',{staticClass:"mine-no-coupon"},[_c('img',{attrs:{"src":_vm.image,"alt":"noCourse"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }